export default __webpack_public_path__ + "static/media/Nostalgic Embrace of the Old Days.620a611e.png";